
import React, { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { EventFormValues } from '../schemas/eventFormSchema';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users, Award } from "lucide-react";

interface AttendanceOptionsProps {
  form: UseFormReturn<EventFormValues>;
}

const AttendanceOptions = ({ form }: AttendanceOptionsProps) => {
  const postAccredited = form.watch("postAccredited");

  // Effect to clear credit points when postAccredited is true
  useEffect(() => {
    if (postAccredited) {
      form.setValue('creditPoints', '', { shouldDirty: true });
    }
  }, [postAccredited, form]);

  return (
    <Card className="border-2 border-medihub-primary/20">
      <CardHeader className="bg-medihub-primary/10 pb-2">
        <CardTitle className="text-lg flex items-center gap-2 text-medihub-primary">
          <Users className="h-5 w-5" />
          Részvételi információk
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-4 space-y-4">
        <FormField
          control={form.control}
          name="maxAttendees"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Tervezett létszám</FormLabel>
              <FormControl>
                <Input
                  type="number"
                  placeholder="pl. 50"
                  {...field}
                />
              </FormControl>
              <FormDescription>
                Opcionális. Az eseményen résztvevők maximális száma.
              </FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <FormField
            control={form.control}
            name="postAccredited"
            render={({ field }) => (
              <FormItem className="flex flex-row items-center justify-between p-3 border rounded-md">
                <div className="space-y-0.5">
                  <FormLabel>Utóakkreditált képzés</FormLabel>
                  <FormDescription>
                    Az esemény utóakkreditált orvosi képzés
                  </FormDescription>
                </div>
                <FormControl>
                  <Switch
                    checked={field.value}
                    onCheckedChange={(checked) => {
                      field.onChange(checked);
                      if (checked) {
                        // Clear credit points immediately when switching to post-accredited
                        form.setValue('creditPoints', '', { shouldDirty: true });
                      }
                    }}
                  />
                </FormControl>
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="creditPoints"
            render={({ field }) => (
              <FormItem>
                <FormLabel className="flex items-center gap-2">
                  <Award className="h-4 w-4" />
                  Kreditpontok
                </FormLabel>
                <FormControl>
                  <Input
                    type="number"
                    placeholder="pl. 20"
                    disabled={postAccredited}
                    {...field}
                  />
                </FormControl>
                <FormDescription>
                  {postAccredited
                    ? "Az utóakkreditált képzések esetén a kreditpontok még nem ismertek."
                    : "Nem utóakkreditált képzés esetén megadhatja a kreditpontok számát."}
                </FormDescription>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default AttendanceOptions;
